import { render, staticRenderFns } from "./_salesReturns.vue?vue&type=template&id=22cf3679&scoped=true&"
import script from "./_salesReturns.vue?vue&type=script&lang=js&"
export * from "./_salesReturns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22cf3679",
  null
  
)

export default component.exports